const { useEffect, useState } = wp.element;

const Component = ({ hasAdditionalServices, setHasAdditionalServices, additionalServices, additionalServicesOptions, addOrRemoveAdditionalService }) => {
    return (
        <>
            <div className="section" id="section-additional-services">
                <div className="container grid">
                    <h2 className="section-title">Ønsker du å oppgradere med tilleggsbehandlinger?</h2>
                    <p className="section-description">Velg fra listen under.</p>

                    <ul className="select-list">
                        {
                            additionalServicesOptions.map((item, index) => {
                                return (
                                    <li onClick={() => { addOrRemoveAdditionalService(item) }} className={`item ${additionalServices?.includes(item) ? 'active' : ''}`} key={index}>
                                        <div className="check">
                                            <svg width="18" height="13" viewBox="0 0 18 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M6.54961 13.0001L0.849609 7.3001L2.27461 5.8751L6.54961 10.1501L15.7246 0.975098L17.1496 2.4001L6.54961 13.0001Z" fill="white"/>
                                            </svg>
                                        </div>
                                        <div className="text">{item.name}</div>
                                    </li>
                                )
                            })
                        }
                    </ul>
                </div>
                
                {
                    additionalServices &&
                    <svg className="progress-arrow" width="64" height="32" viewBox="0 0 64 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0 0H64L32 32L0 0Z" fill="currentColor"/>
                    </svg>
                }
            </div>
        </>
    )
}

export default Component;